import createRestfulModule from './restful-module'

export default createRestfulModule({

  state: {
    path: 'member/activity/banners', // 资源路径
    defaultRels: [], // 默认需要的关联数据
  },
})
